import { render, staticRenderFns } from "./CDRMixin.vue?vue&type=template&id=85ffb77c&"
import script from "./CDRMixin.vue?vue&type=script&lang=js&"
export * from "./CDRMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports